<div class="wrapper">
  <app-resp-popup-title i18n="@@TermsOfServicePopupTitle">
    You must accept the Terms of Service
  </app-resp-popup-title>
  <app-resp-popup-content>
    <div class="body" [innerHTML]="html"></div>
    <div class="form">
      <form [formGroup]="form">
        <frm-check
          #check
          formControlName="accept"
          label="I agree to the Terms of Service listed above"
          i18n-label="@@TermsOfServicePopupAcceptCheckboxLabel"
        ></frm-check>
        @if (!check.checked && error) {
          <mat-error>{{
            data.message
          }}</mat-error>
        }
      </form>
    </div>
  </app-resp-popup-content>
  <app-resp-popup-actions>
    <div class="centered">
      @if (canAccept) {
        <ctrl-btn-accept
          [disabled]="!canAccept"
          (click)="onAccept()"
        ></ctrl-btn-accept>
      }
      @if (!canAccept) {
        <ctrl-btn-cancel
          (click)="onCancel()"
          matTooltip="{{ data.message }}"
          matTooltipPosition="left"
          matTooltipHideDelay="500"
          matTooltipClass="tt"
        ></ctrl-btn-cancel>
      }
    </div>
  </app-resp-popup-actions>
</div>